export default {"src":"/_next/static/media/orange.1e648216.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};